module.exports = __webpack_public_path__ + "static/img/areaCheck.df1f0f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/areaCheck.jpg
// module id = 7FFW
// module chunks = 1